import { Component, EventEmitter, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Toast } from "src/app/ui/components/toast/toast";
import { AddClusterProduct } from "src/app/ui/models/domains/pbm/clusters/add-cluster-product.model";
import { LoadingService } from "src/app/ui/services/loading.service";
import { ClustersService } from "src/app/ui/services/pbm/clusters.service";
import { ConfirmDialog } from "../../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "add-product-dialog",
  templateUrl: "./add-product-dialog.component.html",
  styleUrls: ["./add-product-dialog.component.scss"],
})
export class AddProductDialogComponent implements OnInit {
  public productFormGroup: UntypedFormGroup;
  public addClusterProductDialogEvent = new EventEmitter();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private toast: Toast,
    private clusterService: ClustersService,
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {}

  ngOnInit() {
    this.productFormGroup = this.formBuilder.group({
      ean: new UntypedFormControl("", Validators.compose([Validators.required])),
    });
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public emitAddClusterProductEvent(addClusterProduct: AddClusterProduct) {
    this.addClusterProductDialogEvent.emit(addClusterProduct);
    this.closeDialog();
  }

  public async addProduct(): Promise<void> {
    const loadingRef = this.loadingService.beginLoading();

    try {
      const ean = this.productFormGroup.value.ean;

      if (this.productFormGroup.valid) {
        const addClusterProduct = new AddClusterProduct();
        addClusterProduct.setClusterId(this.data);
        addClusterProduct.setEan(ean);

        await this.clusterService.addClusterProduct(addClusterProduct);
        this.closeDialog();
        this.emitAddClusterProductEvent(addClusterProduct);
        this.toast.showSuccessToast("Produto adicionado com sucesso");
      } else {
        this.toast.showWarningToast("Preencha as informações corretamente.");
      }
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      loadingRef.closeLoading();
    }
  }
}
